module.exports = __webpack_public_path__ + "img/special-ops-logo.ea9d30fb.png";